import { render, staticRenderFns } from "./CareLevelChecker.vue?vue&type=template&id=37c3e532&"
import script from "./CareLevelChecker.vue?vue&type=script&lang=js&"
export * from "./CareLevelChecker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports